import settings from '../settings'

const { sessionStorageKey } = settings

export default function getPrevAuth() {
  const data = sessionStorage.getItem(sessionStorageKey)
  return data ? JSON.parse(data) : null
}
